type MapsRepositoryDependencies = {
  directionsService: google.maps.DirectionsService
  geocodeService: google.maps.Geocoder
}

type Coordinate = {
  lat: number
  lng: number
}

export class MapsRepository {
  private directionsService: google.maps.DirectionsService
  private geocodeService: google.maps.Geocoder

  constructor({ directionsService, geocodeService }: MapsRepositoryDependencies) {
    this.directionsService = directionsService
    this.geocodeService = geocodeService
  }

  async route(coordinates: Coordinate[]): Promise<google.maps.DirectionsResult> {
    const [first] = coordinates
    const last = coordinates[coordinates.length - 1]

    const wayPointArray = coordinates.slice(1, -1).map(({ lat, lng }) => ({
      location: new google.maps.LatLng(lat, lng),
    }))

    const request: google.maps.DirectionsRequest = {
      destination: new google.maps.LatLng(last.lat, last.lng),
      origin: new google.maps.LatLng(first.lat, first.lng),
      provideRouteAlternatives: true,
      travelMode: 'DRIVING' as any, // casting due to mock lib missing mock implementation
      waypoints: wayPointArray,
    }

    return this.directionsService.route(request)
  }

  async geocode(address: string) {
    const response = await this.geocodeService.geocode({ address })
    return response ? response.results : []
  }
}
